const RANKING_ITEMS = [
  { rank: 1, title: '热辣滚烫', category: '电影', hot: '998万', trend: 'up' },
  { rank: 2, title: '繁花', category: '电视剧', hot: '876万', trend: 'up' },
  { rank: 3, title: '第二十条', category: '电影', hot: '765万', trend: 'up' },
  { rank: 4, title: '飞驰人生2', category: '电影', hot: '654万', trend: 'stable' },
  { rank: 5, title: '与凤行', category: '电视剧', hot: '589万', trend: 'up' },
  { rank: 6, title: '庆余年2', category: '电视剧', hot: '543万', trend: 'down' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              热播排行榜
            </h2>
            <p className="text-sm text-foreground-600">实时热度排行，发现最受欢迎的好内容</p>
          </div>

          <div className="bg-background-50 border border-background-200 rounded-xl overflow-hidden">
            {RANKING_ITEMS.map((item, idx) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 px-5 py-4 ${
                  idx < RANKING_ITEMS.length - 1 ? 'border-b border-background-200' : ''
                } hover:bg-background-100 transition-colors cursor-pointer`}
              >
                <div className="flex-shrink-0 w-8 text-center">
                  {item.rank <= 3 ? (
                    <span
                      className={`inline-flex items-center justify-center w-7 h-7 rounded-full text-xs font-bold text-white ${
                        item.rank === 1
                          ? 'bg-primary-500'
                          : item.rank === 2
                          ? 'bg-accent-500'
                          : 'bg-secondary-500'
                      }`}
                    >
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-sm font-medium text-foreground-500">
                      {item.rank}
                    </span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500">{item.category}</span>
                </div>

                <div className="flex-shrink-0 flex items-center gap-2">
                  <span className="text-xs text-secondary-500 whitespace-nowrap">
                    热度 {item.hot}
                  </span>
                  <span className="flex items-center w-5 h-5 justify-center">
                    <i
                      className={`text-xs ${
                        item.trend === 'up'
                          ? 'ri-arrow-up-line text-primary-500'
                          : item.trend === 'down'
                          ? 'ri-arrow-down-line text-secondary-500'
                          : 'ri-subtract-line text-foreground-400'
                      }`}
                    ></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}